module.exports = __webpack_public_path__ + "img/FB_IMG_1434717161734.acf6b4d3.jpg";